import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { CompanyInfos } from 'src/app/models/companyInfos';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  styleUrls: ['./profil.component.css'],
})
export class ProfilComponent implements OnInit, OnDestroy {
  userForm!: FormGroup;
  isEditing = false;
  user!: User;
  private unsubscribe$ = new Subject<void>();
  clientInfos!: CompanyInfos;
  isLoading = true;

  constructor(private fb: FormBuilder, private authService: AuthService) {}

  ngOnInit() {
    this.getUserInfos();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(); // Déclenche la désinscription
    this.unsubscribe$.complete();
  }

  private getUserInfos(): void {
    this.authService
      .getUserInfos('company')
      .pipe(
        takeUntil(this.unsubscribe$) // S'assure de se désabonner au bon moment
      )
      .subscribe((result) => {
        this.clientInfos = {
          customerId: result.data.company.customerId,
          name: result.data.company.name,
          ninea: result.data.company.ninea,
          address: result.data.company.address,
          tickets: result.data.company.tickets,
          ticketAmount: result.data.company.ticketAmount,
          ownerFirstName: result.data.company.ownerFirstName,
          ownerLastName: result.data.company.ownerLastName,
          ownerEmail: result.data.company.ownerEmail,
          ownerPhone: result.data.company.ownerPhone,
        };

        // Initialize the form after data is loaded
        this.initializeForm();
        this.isLoading = false;
      });
  }

  private initializeForm(): void {
    this.userForm = this.fb.group({
      sub: [{ value: this.clientInfos.customerId, disabled: true }],
      name: [{ value: this.clientInfos.name, disabled: true }],
      ninea: [{ value: this.clientInfos.ninea, disabled: true }],
      address: [{ value: this.clientInfos.address, disabled: true }],
      email: [{ value: this.clientInfos.ownerEmail, disabled: true }],
      phone: [{ value: this.clientInfos.ownerPhone, disabled: true }],
      tickets: [{ value: this.clientInfos.tickets, disabled: true }],
    });
  }

    /** Initiales du nom de l'entreprise pour l'avatar (ex. "Auchan Sénégal" -> "AS") */
  get initials(): string {
    const words = (this.clientInfos?.name || '').trim().split(/\s+/).filter(Boolean);
    return (words.slice(0, 2).map((w) => w[0]).join('') || '?').toUpperCase();
  }

  get ownerName(): string {
    return [this.clientInfos?.ownerFirstName, this.clientInfos?.ownerLastName]
      .filter(Boolean)
      .join(' ');
  }

  /** Annuler : on remet les valeurs d'origine avant de verrouiller les champs */
  cancelEdit() {
    this.userForm.patchValue({
      address: this.clientInfos.address,
      email: this.clientInfos.ownerEmail,
      phone: this.clientInfos.ownerPhone,
    });
    if (this.isEditing) {
      this.toggleEdit();
    }
  }
  toggleEdit() {
    this.isEditing = !this.isEditing;
    if (this.isEditing) {
      this.userForm.get('email')?.enable();
      this.userForm.get('phone')?.enable();
      this.userForm.get('address')?.enable();
    } else {
      this.userForm.get('email')?.disable();
      this.userForm.get('phone')?.disable();
      this.userForm.get('address')?.disable();
    }
  }

  saveChanges() {
    const updatedUser: User = {
      ...this.user,
      email: this.userForm.value.email,
      phone: this.userForm.value.phone,
    };
    //this.userService.updateUser(updatedUser);
    this.toggleEdit();
  }
}
